export const TERMINAL_AI_RUN_SOCKET_GRACE_MS = 15_000

const ACTIVE_AI_RUN_STATUSES = new Set(['pending', 'running', 'started', 'submitted'])

export type AnswerLike =
    | {
          ai_runs?: Array<{ status?: unknown }> | null
      }
    | null
    | undefined

export type AnswerJobLike =
    | {
          ai_run_id?: unknown
          run_id?: unknown
          status?: unknown
      }
    | null
    | undefined

export function isActiveAiRunStatus(status: unknown) {
    return typeof status === 'string' && ACTIVE_AI_RUN_STATUSES.has(status.toLowerCase())
}

export function answerHasActiveAiRun(answer: AnswerLike) {
    const runs = Array.isArray(answer?.ai_runs) ? answer.ai_runs : []
    return runs.some(run => isActiveAiRunStatus(run?.status))
}

export function answerJobHasActiveAiRun(answerJob: AnswerJobLike) {
    const hasAiRunId =
        (typeof answerJob?.ai_run_id === 'string' && answerJob.ai_run_id.trim().length > 0) ||
        (typeof answerJob?.run_id === 'string' && answerJob.run_id.trim().length > 0)
    return hasAiRunId && isActiveAiRunStatus(answerJob?.status)
}

export function answerHasActiveAiRunSocketWork({
    answer,
    answerJob,
}: {
    answer: AnswerLike
    answerJob?: AnswerJobLike
}) {
    return answerHasActiveAiRun(answer) || answerJobHasActiveAiRun(answerJob)
}

export function shouldKeepAnswerChannelSubscribed({
    isVisible,
    answer,
    answerJob,
    isEnteringTerminalGrace = false,
    terminalGraceUntil = 0,
    now = Date.now(),
}: {
    isVisible: boolean
    answer: AnswerLike
    answerJob?: AnswerJobLike
    isEnteringTerminalGrace?: boolean
    terminalGraceUntil?: number
    now?: number
}) {
    if (isVisible) return true
    if (answerHasActiveAiRunSocketWork({ answer, answerJob })) return true
    if (isEnteringTerminalGrace) return true
    return terminalGraceUntil > now
}
